import { proxied } from "@/lib/api";


const ShravanOfferBlog = ({ settings = {} }) => (  <section className="bg-[#F5EEDD] py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-14 md:space-y-20">
      {/* Section title */}
      <div className="text-center max-w-3xl mx-auto">
       {/* <div className="text-[#8B2323] text-xs md:text-sm tracking-[0.5em] uppercase mb-3">Shravan Special</div> */}
        <h2 className="font-serif italic text-4xl md:text-6xl tracking-tight text-[#C89838]">
          {settings.shravan_offer_title || "Shravan 2025-26 Exclusive Offer"}
        </h2>
        <div className="h-[2px] w-16 bg-[#D4AF37] mt-6 mx-auto" />
      </div>

      {/* Row 1: Image LEFT · Content RIGHT */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
        <div className="relative order-1">
          <div className="aspect-[4/3] rounded-3xl overflow-hidden bg-[#faf6f0]">
            <img src={proxied(settings.shravan_offer_image_1)} alt="Shravan Offer" className="w-full h-full object-cover" />
          </div>
        </div>
        <div className="order-2">
          <div className="text-[#8B2323] text-[10px] tracking-[0.5em] uppercase mb-3">{settings.shravan_offer_kicker || "The Divine Season"}</div>
          <h3 className="font-serif text-2xl md:text-4xl text-[#2D2825] leading-tight">
            Siddha Mala — A Sacred Legacy of 25 Years
          </h3>
          <p className="mt-5 text-[#5C544F] text-sm md:text-base leading-relaxed whitespace-pre-line">
            {settings.shravan_offer_paragraph_1}
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default ShravanOfferBlog;
